(() => {
  function getContext() {
    try {
      const params = new URLSearchParams(window.location.search);
      const path = window.location.pathname.replace(/\/$/, '');
      return params.get('grupo') === 'revenda' || /\/pages\/revenda$/.test(path) ? 'revenda' : 'consumo';
    } catch (_) { return 'consumo'; }
  }

  function initKitSelector(kitWrapper) {
    if (!kitWrapper || kitWrapper.dataset.initialized === 'true') return;
    const sectionId = kitWrapper.dataset.sectionId;
    const nativePicker = document.getElementById(`variant-selects-${sectionId}`);
    if (!sectionId || !nativePicker) return;
    kitWrapper.dataset.initialized = 'true';

    const grouped = kitWrapper.dataset.groupedVariants === 'true';
    const context = grouped ? getContext() : '';
    document.documentElement.setAttribute('data-marita-variant-context', context || 'consumo');
    window.maritaVariantContext = context || 'consumo';
    kitWrapper.dataset.variantGroup = context;

    const tiles = Array.from(kitWrapper.querySelectorAll('.VariantTile'));
    const emptyMessage = kitWrapper.querySelector('.KitSelector__Empty');
    let variantData = [];
    let enforcingAllowedVariant = false;
    try {
      const json = nativePicker.querySelector('[type="application/json"]');
      if (json) variantData = JSON.parse(json.textContent) || [];
    } catch (error) { console.warn('Marita: não foi possível ler os dados das variantes.', error); }

    const tileGroup = (tile) => String(tile?.dataset.variantGroup || '').trim().toLowerCase();
    const isAllowed = (tile) => !grouped || tileGroup(tile) === context;
    const findTile = (id) => tiles.find((tile) => tile.dataset.variantId === String(id));
    const firstAllowed = (availableOnly) => tiles.find((tile) => {
      if (!isAllowed(tile)) return false;
      const input = tile.querySelector('.VariantTile__Input');
      return !availableOnly || (!tile.classList.contains('is-soldout') && input && !input.disabled);
    }) || null;

    tiles.forEach((tile) => {
      const allowed = isAllowed(tile);
      tile.hidden = !allowed;
      tile.setAttribute('aria-hidden', allowed ? 'false' : 'true');
    });
    if (emptyMessage) emptyMessage.hidden = tiles.some(isAllowed);

    const updateUI = (id) => tiles.forEach((tile) => {
      const active = isAllowed(tile) && tile.dataset.variantId === String(id);
      tile.classList.toggle('is-selected', active);
      const radio = tile.querySelector('.VariantTile__Input');
      if (radio) radio.checked = active;
    });

    function triggerVariant(id) {
      const target = findTile(id);
      if (!target || !isAllowed(target)) return false;
      const variant = variantData.find((item) => String(item.id) === String(id));
      if (!variant) return false;
      const options = [variant.option1, variant.option2, variant.option3];
      nativePicker.querySelectorAll('fieldset').forEach((fieldset, index) => {
        if (!options[index]) return;
        const select = fieldset.querySelector('select');
        if (select) select.value = options[index];
        else fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => { radio.checked = radio.value === options[index]; });
      });
      nativePicker.dispatchEvent(new Event('change', { bubbles: true }));
      updateUI(id);
      return true;
    }

    const preloaded = new Set();
    const preload = (tile) => {
      if (!tile || !isAllowed(tile)) return;
      const src = tile.dataset.variantImage;
      if (!src || preloaded.has(src)) return;
      preloaded.add(src);
      const image = new Image(); image.decoding = 'async'; image.src = src;
    };
    const select = (tile) => {
      if (!tile || !isAllowed(tile) || tile.classList.contains('is-soldout')) return;
      const input = tile.querySelector('.VariantTile__Input');
      if (!input || input.disabled) return;
      preload(tile); triggerVariant(input.value);
    };

    ['pointerover', 'focusin'].forEach((name) => kitWrapper.addEventListener(name, (event) => preload(event.target.closest('.VariantTile'))));
    kitWrapper.addEventListener('touchstart', (event) => preload(event.target.closest('.VariantTile')), { passive: true });
    kitWrapper.addEventListener('click', (event) => {
      const tile = event.target.closest('.VariantTile');
      if (!tile || !kitWrapper.contains(tile)) return;
      event.preventDefault(); select(tile);
    });
    kitWrapper.addEventListener('keydown', (event) => {
      const tile = event.target.closest('.VariantTile');
      if (!tile || !isAllowed(tile)) return;
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(tile); }
    });

    document.addEventListener('product:variant-change', (event) => {
      if (!event.detail || String(event.detail.sectionId) !== String(sectionId) || !event.detail.variant) return;
      const tile = findTile(event.detail.variant.id);
      if (grouped && (!tile || !isAllowed(tile))) {
        if (enforcingAllowedVariant) return;
        const fallback = firstAllowed(true) || firstAllowed(false);
        const input = fallback?.querySelector('.VariantTile__Input');
        if (input) {
          enforcingAllowedVariant = true;
          triggerVariant(input.value);
          window.setTimeout(() => { enforcingAllowedVariant = false; }, 0);
        }
        return;
      }
      if (tile) updateUI(event.detail.variant.id);
    });

    const requested = new URLSearchParams(window.location.search).get('variant');
    const requestedTile = requested ? findTile(requested) : null;
    const selected = kitWrapper.querySelector('.VariantTile.is-selected');
    const initial = requestedTile && isAllowed(requestedTile) ? requestedTile :
      selected && isAllowed(selected) ? selected : firstAllowed(true) || firstAllowed(false);
    const input = initial?.querySelector('.VariantTile__Input');
    if (input) triggerVariant(input.value);
  }

  function init(scope = document) { scope.querySelectorAll('.KitSelector[data-section-id]').forEach(initKitSelector); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
